import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    var t = to.name;
    var f = from.name;
    if (t == "vacancy" || t == "work") {
      if (f == "vacancy" || f == "work") {
        return {};
      }
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  // Auth guards
  const isAuthed = !!store.getters["auth/isAuthenticated"];
  const role = store.getters["auth/role"];
  if (to.meta && to.meta.guestOnly && isAuthed) {
    if (role === "Clinic") return next({ name: "candidates" });
    if (role === "Nurse") return next({ name: "profile-nurse" });
    return next({ name: "home" });
  }
  if (to.meta && to.meta.requiresRole) {
    if (!isAuthed) return next({ name: "login", query: { returnUrl: to.fullPath } });
    if (role !== to.meta.requiresRole) return next({ name: "home" });
  }

  // Klinika qeydiyyat — yalnız adminin icazə verdiyi dillər üçün
  if (to.name === "register-clinic") {
    // Soyuq yükləmədə (URL-i birbaşa paste edəndə) featureSettings hələ
    // App.vue tərəfindən yüklənməmiş ola bilər; qərardan əvvəl gözlə, yoxsa
    // default dəyərə görə (yalnız de:true) səhvən home-a yönləndirilir.
    if (!store.state.featureSettings.loaded) {
      await store.dispatch("featureSettings/fetch");
    }
    const lang = store.state.lang || localStorage.getItem("igaplus-client-language") || "az";
    const allowed = store.getters["featureSettings/canRegisterClinic"](lang);
    if (!allowed) return next({ name: "home" });
  }

  // Existing language-based redirects
  let lang = localStorage.getItem("igaplus-client-language");
  if (to.name === "career") {
    if (lang === "de") {
      return next({ name: "vacancy" });
    } else {
      return next({ name: "work" });
    }
  }
  if (to.name === "work" || to.name === "vacancy") {
    if (lang === "de") {
      return next({ name: "home" });
    } else {
      return next();
    }
  }
  if (to.name === "get-employee" || to.name === 'nurses') {
    if (lang !== "de") {
      return next({ name: "home" });
    } else {
      return next();
    }
  } else {
    return next();
  }
});

export default router;
